import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_CLEAR_FILTERS,
  TEST_PURCHASE_SET_FILTERS_SELECTED,
} from '../../../../../actions/actionTypes';
import FilterByEnum from '../../../../../enumerations/FilterBy';

const defaultState = FilterByEnum.CUSTOMER.name;

const filterBy = (state = defaultState, action) => {
  switch (action.type) {
    case TEST_PURCHASE_SET_FILTERS_SELECTED:
      return action.payload.filterBy;

    case TEST_PURCHASE_CLEAR_FILTERS:
    case TEST_PURCHASE_CLEAR:
      return defaultState;

    default:
      return state;
  }
};

export default filterBy;
